module.exports = __webpack_public_path__ + "img/shape-3-title.c4f59b6a.svg";